import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './finding-document.controller';
import directive from './finding-document.directive';
import editFindingDocumentDialog from './dialog.editFindingDocumentDialog';

export default angular.module('app.components.advisory.auditTrail.findingDocument', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  editFindingDocumentDialog,
])
  .directive('amFindingDocument', directive)
  .controller('FindingDocumentController', controller)
  .name;

console.log('app.components.advisory.auditTrail.findingDocument created');
